import type { FullPublicPotentialProfileFragment } from 'apollo-gql'
import getMarketTrackingProperties from 'lib/tracking/avo/utils/getMarketTrackingProperties'

type TrackPotentialProfileSubscribed = {
  potentialProfile: FullPublicPotentialProfileFragment
}

const trackPotentialProfileSubscribed = async (
  parameters: TrackPotentialProfileSubscribed,
): Promise<void> => {
  const { potentialProfile } = parameters

  const { potentialProfileSubscribed } = await import('./sdk')
  potentialProfileSubscribed({
    ...getMarketTrackingProperties(),
    potentialProfileId: potentialProfile.id,
    potentialProfileName: potentialProfile.name,
  })
}

export default trackPotentialProfileSubscribed
